<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useDataStore } from '@/stores/useDataStore';
import { useAuthStore } from '@/stores/useAuthStore';
import Maintenance from '@/components/Maintenance.vue';

const authStore = useAuthStore();
const dataStore = useDataStore();

const user = computed(() => {
  const name = authStore.name;
  return name ? name.charAt(0).toUpperCase() + name.slice(1) : null;
});

// Charger les données au montage
onMounted(async () => {
  await dataStore.loadBasicData();
});
</script>

<template>
  <Maintenance />
  <div v-if="authStore.isAuthenticated && authStore.scopes.includes('reader')" class="home-container">
    <h1 class="title">{{ $t('welcome') }} {{ user }}</h1>
    <p class="subtitle">{{ $t('chooseSection') }}</p>

    <div class="button-grid">
      <router-link to="/cultures" class="home-button">🌾 {{ $t('cultures') }}</router-link>
      <router-link to="/strains" class="home-button">🦠 {{ $t('algae_library') }}</router-link>
      <router-link to="/pbrs" class="home-button">🧫 PBRs</router-link>
      <router-link to="/prelevement" class="home-button">🧪 {{ $t('samples') }}</router-link>
      <router-link to="/recoltes" class="home-button">🌿 {{ $t('harvests') }}</router-link>
      <router-link to="/control" class="home-button">🛰️ {{ $t('control') }}</router-link>
      <router-link to="/history" class="home-button">📜 {{ $t('history') }}</router-link>
    </div>
  </div>

  <div v-else class="centered-block">
    <h2>{{ $t('loginRequiredTitle') }}</h2>
    <p>{{ $t('loginRequiredMessage') }}</p>
  </div>
</template>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.title {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #606f7b;
}

.button-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.home-button {
  display: block;
  padding: 20px;
  background-color: #00bcd4;
  color: white;
  text-decoration: none;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, background-color 0.3s;
  text-align: center;
}

.home-button:hover {
  background-color: #0097a7;
  transform: translateY(-3px);
}
</style>